export default "__VITE_ASSET__DD2BtK7J__"